export default "__VITE_ASSET__9f21e127__"